/**
 * 多维分析和探索分析 公共的 图表组件
 */
export default {
  dbl_chart_statistical_metric: "Statistical Metric",
  dbl_chart_select_placeholder: "Please select",
  dbl_chart_table: "Table",
  dbl_chart_line: "Line Chart",
  dbl_chart_bar: "Bar Chart",
  dbl_chart_switch: "Chart Switch",
  dbl_chart_pie: "Pie Chart",
  dbl_chart_compare: 'Compare',
  dbl_chart_download: "Download",
  dbl_table_page: "Page",
  dbl_table_total: "Total {total} Items",
  dbl_table_total_more: "Total {total} Items,Exceeding the front-end display limit, please download the data and make statistics",
	
  dbl_chart_limit_info: 'Row limit: 2000',
  dbl_chart_row_limit_info: 'Row limit',
  dbl_chart_row: 'Row limit exceeded. Results may be incomplete. Download for more data.',
  dbl_chart_row_over_limit: 'Raw limit reached, Result may be incomplete.',
  dbl_chart_row_red_info: 'The row limit set for the chart was reached. <br/>The chart may show partial data.',
  dbl_chart_row_max_limit_info: 'Up to 50000 lines',
  dbl_chart_modal_download_set: 'Download Settings',
  dbl_chart_modal_download_dataSource: 'Data Rows',
  dbl_chart_modal_download_warning: 'Data export limit: 1,000,000 rows per batch. For larger datasets, refine query filters and export in multiple batches.',
  dbl_chart_limit_bubble: "The system has a maximum limit on the display of query results, with a maximum of 2000 results displayed.",
  dbl_chart_graph_settings: "Chart Configuration",
  dbl_chart_top: "Top",
  dbl_chart_dynamic_series: "Dynamic Series",
  dbl_chart_and_others: "and Others",
  dbl_chart_only: "Only",
  dbl_chart_sort: "Sort",
  dbl_chart_sort_by: "Sort By",
  dbl_chart_default_sorting: "System Default Sort",
  dbl_chart_custom_metric_sort: "Metric",
  dbl_chart_dataset_field_sort: "Field Sort",
  dbl_chart_dataset_field_sort_field: "Field",
  dbl_chart_dataset_field_sort_agg: "Aggregation",
  dbl_chart_dataset_field_sort_custom_group: "Custom Fields",
  dbl_chart_dataset_field_sort_placeholder: "Please select",
  dbl_chart_low: "Ascending", 
  dbl_chart_high: "Descending",
  dbl_chart_confirm: "Confirm",
  dbl_chart_cancel: "Cancel",
  dbl_chart_metric: "Metric",
  dbl_chart_axis: 'Manual Sort',
  dbl_chart_mixed_tips: 'New feature: Y-axis configuration can be set here.',
  dbl_chart_primary_axis: 'Primary Y-Axis',
  dbl_chart_secondary_axis: 'Secondary Y-Axis',
  dbl_chart_primary_name: 'Y-Axis Name',
  dbl_chart_xaxis_name: 'X-Axis Name',
  dbl_chart_primary_metic: 'Metric',
  dbl_chart_primary_chart_type: 'Chart Type',
  dbl_chart_dual_y_axis: 'Dual Y-Axis',
  dbl_chart_dual_y_axis_min_metric_tip: 'At least 2 metrics are required to enable dual Y-Axis',
  dbl_chart_dual_y_axis_metric_tip: 'After selecting one side, the remaining metrics are auto-assigned to the other side',
  dbl_chart_dual_y_axis_metric_required: 'At least 1 metric required',
  dbl_chart_dual_y_axis_metric_allocation_required: 'All metrics must be assigned to primary or secondary Y-axis',
  dbl_chart_primary_basic_info: 'Basic Info',
  dbl_chart_primary_basic_info_optional: 'Optional',
  dbl_chart_primary_field_setting: 'Field Setting',
  dbl_chart_field_column_sorting: 'Field Column Sorting',
  dbl_chart_primary_description: 'Description',
  dbl_chart_primary_duplicate_name: 'Duplicate naming',
  dbl_chart_display_limit_info: 'The first dimension serves as the X-axis of the graph. Based on the first metric, the number of displays for the remaining dimension value combinations can be set here.',
  dbl_chart_stacked_limit_info: 'The first dimension serves as the X-axis of the graph, and the number of displays for the combinations of the remaining dimension values can be set here.',
  dbl_chart_topN_info: 'The first dimension serves as the {type}-axis of the graph, and the number of {type}-axis dimensions displayed can be set here',
  dbl_chart_axis_setting: 'Axis Setting',
  dbl_chart_stacked_layer_display_limit: 'Stacked Layer Display Limit',
  dbl_chart_display_limit: 'Display Limit',
  dbl_chart_null_handing: 'Null Handling',
  dbl_chart_null_ui_label: 'Null Handling',
  dbl_chart_null_ui_break: 'Break lines',
  dbl_chart_null_ui_zero: 'Set to 0',
  dbl_chart_null_ui_ignore: 'Ignore nulls',

  dbl_chart_data_label: 'Data Label',
  dbl_chart_show_values: 'Show Values',
  dbl_chart_all_values: 'All Values',
  dbl_chart_none: 'None',
  dbl_chart_show_7_values: 'Show 7 Values',
  dbl_chart_x_axis: 'X-Axis',
  dbl_chart_y_axis: 'Y-Axis',
  dbl_chart_yaxis_range_title: 'Display Range: Automatic Interval',
  dbl_chart_yaxis_range_tip: 'Automatically calculate the Y-axis tick values based on the minimum and maximum values of the query results',
  dbl_chart_field_setting_original: 'Original Value',
  dbl_chart_field_setting_url: 'Set as URL',

  dbl_chart_description_edit_title: 'Edit Description',
  dbl_chart_description_edit_waring: 'Empty the content and no description are displayed',
  dbl_chart_description_edit_placeholder: 'Please enter content',

  dbl_chart_statistics: 'Display Statistics',
  dbl_chart_statistics_placeholder: 'Please select metrics',
  dbl_chart_statistics_sum: 'Sum',
  dbl_chart_statistics_avg: 'Avg',
  dbl_chart_statistics_avgNotNull: 'Avg (≠Null)',
  dbl_chart_statistics_max: 'Max Value',
  dbl_chart_statistics_min: 'Min Value',
  dbl_chart_statistics_sum_tooltip: 'The total value of all the data in this column. ',
  dbl_chart_statistics_avg_tooltip: 'The avergae of all data in this column, including null values.',
  dbl_chart_statistics_avgNotNull_tooltip: 'The avergae of all data in this column, excluding null values. ',
  dbl_chart_statistics_max_tooltip: 'The maximum of all data in this column. ',
  dbl_chart_statistics_min_tooltip: 'The minimum of all data in this column. ',
  
  dbl_chart_config_tip_reference_lines: 'New feature: reference lines can be set here.',
  dbl_chart_style: 'Style',
  dbl_chart_advanced: 'Advanced',
  dbl_chart_advanced_reference_line: 'Reference Line',
  dbl_chart_advanced_add_reference_line: 'Add Reference Line',
  dbl_chart_advanced_reference_line_index: 'Reference Line {count}',
  dbl_chart_advanced_reference_line_style: 'Style',
  dbl_chart_advanced_reference_line_value: 'Value',
  dbl_chart_advanced_reference_line_color: 'Color',
  dbl_chart_advanced_reference_line_label: 'Label',
  dbl_chart_advanced_reference_line_label_placeholder: 'Please enter label',
  dbl_chart_advanced_reference_line_dashed: 'Dashed',
  dbl_chart_advanced_reference_line_solid: 'Solid',
  dbl_chart_advanced_reference_line_fixed: 'Fixed Value',
  dbl_chart_advanced_reference_line_fixed_placeholder: 'Please enter value',
  dbl_chart_advanced_reference_line_restore: 'Restore Settings',
  
  // 地图颜色设置
  dbl_chart_map_title: 'Color',
  dbl_chart_map_restore: 'Restore Settings',
  dbl_chart_map_level1: 'Level 1',
  dbl_chart_map_level2: 'Level 2',
  dbl_chart_map_level3: 'Level 3',
  dbl_chart_map_level4: 'Level 4',
  dbl_chart_map_level5: 'Level 5',
  dbl_chart_map_system_default: 'System Default',
  dbl_chart_map_color_theme: 'Color Theme',
  dbl_chart_map_color_blue: 'Blue',
  dbl_chart_map_color_yellow: 'Yellow',
  dbl_chart_map_color_green: 'Green',
  dbl_chart_map_color_red: 'Red',
  dbl_chart_map_color_custom: 'Custom',
  
  // x轴文本展示方式
  dbl_chart_x_label: 'Axis Label',
  dbl_chart_auto: 'Auto',
  dbl_chart_horizontal: 'Horizontal',
  dbl_chart_map_color_light: 'Light',
  dbl_chart_map_color_dark: 'Dark',
  dbl_chart_map_color1: 'Color 1',
  dbl_chart_map_color2: 'Color 2',
  dbl_chart_map_color3: 'Color 3',
  dbl_chart_map_color4: 'Color 4',
  dbl_chart_map_color5: 'Color 5',

  // 词云图
  dbl_chart_count_limit: 'Word Cloud Display Limit',
  dbl_chart_count_limit_info: 'Set the specific number of keywords with the highest displayed metrics here.',
  dbl_chart_count_limit_tip: 'Show the keywords with top metrics',
  dbl_chart_color_setting_title: 'Color',
  dbl_chart_color_setting_restore: 'Restore Settings',
  dbl_chart_color_setting_color_theme: 'Color Theme',
  dbl_chart_color_setting_pure_color: 'Pure Color',
  dbl_chart_color_setting_multi_color: 'Multi-Color',
  dbl_chart_color_setting_sentiment_related: 'Sentiment Related',
  dbl_chart_color_setting_count_related: 'Count - First Metric',
  dbl_chart_color_setting_pure_color_tip: 'Pure color matching scheme, with optional colors.',
  dbl_chart_color_setting_multi_color_tip: 'Multiple color matching schemes, independent of fields.',
  dbl_chart_color_setting_sentiment_related_tip: 'When the name of the second metric field dragged in contains "sentiment", the color is determined by this field. Otherwise, this option will not be available.',
  dbl_chart_color_setting_count_related_tip: 'Color is determined by the first metric field dragged in.',
  dbl_chart_color_setting_sentiment_related_positive: 'Positive',
  dbl_chart_color_setting_sentiment_related_neutral: 'Neutral',
  dbl_chart_color_setting_sentiment_related_negative: 'Negative',
  
  // 列总计占比
  dbl_chart_column_percent_title: 'Percentage of Column Total',
  dbl_chart_column_percent_title_info: 'Select one or more metrics to display as percentages of the column total. The percentage metrics will only be calculated based on the data within the row limit.',
  dbl_chart_column_percent_placeholder: 'Please select metrics',

  // Dimension percentage (aligned with backend dimension_percentage contract)
  dbl_chart_dimension_percentage_title: 'Percentage by Selected Dimension',
  dbl_chart_dimension_percentage_title_info: 'Choose one or more dimensions as the aggregation basis and select metrics to compute their percentage; a new column will be added to show the share of each row relative to the sum of the selected dimension combination. Rows sharing the same dimension combination are grouped and calculated separately.',
  dbl_chart_dimension_percentage_metric_index: 'Percentage of Column Total {count}',
  dbl_chart_dimension_percentage_metric_placeholder: 'Please select',
  dbl_chart_dimension_percentage_metric_dropdown_title: 'Metrics',
  dbl_chart_dimension_percentage_label: 'Header Name',
  dbl_chart_dimension_percentage_label_placeholder: ' Please enter',
  dbl_chart_dimension_percentage_group_by_placeholder: 'Please select',
  dbl_chart_dimension_percentage_group_by_dropdown_title: 'Dimensions',
  dbl_chart_dimension_percentage_add_metric: 'Add',
  dbl_chart_group_by: 'Aggregation',

  // 条件格式
  dbl_chart_conditional_formatting: "Conditional Formatting",
  dbl_chart_condition_batch_config_condition_format: "Batch Configuration Condition Format",
  dbl_chart_condition_bar_chart: "Bar Chart",
  dbl_chart_condition_bar_chart_count: "Bar Chart({count})",
  dbl_chart_condition_numerical: "Numerical Values",
  dbl_chart_condition_numerical_values: "Numerical Values({count})",
  dbl_chart_condition_select_metrics: "Select Metrics",
  dbl_chart_condition_select_metrics_placeholder: "Please select metrics ",
  dbl_chart_condition_merrics: "Merrics",
  dbl_chart_condition_color_theme: "Color Theme",
  dbl_chart_condition_solid_color: "Solid Color",
  dbl_chart_condition_gradient: "Gradient",
  dbl_chart_condition_color_blue: "Blue",
  dbl_chart_condition_color_green: "Green",
  dbl_chart_condition_color_yellow: "Yellow",
  dbl_chart_condition_color_red: "Red",
  dbl_chart_condition_color_red_blue: "Red-blue",
  dbl_chart_condition_color_green_purple: "Green-purple",
  dbl_chart_condition_color_blue_cyan: "Blue-cyan",
  dbl_chart_condition_color_orange_red: "Orange-red",
  dbl_chart_condition_color_purple_pink: "Purple-pink",
  dbl_chart_condition_min: "Min",
  dbl_chart_condition_max: "Max",
  dbl_chart_condition_auto: "Auto",
  dbl_chart_condition_custom_value: "Custom Value",
  dbl_chart_condition_custom_value_placeholder: "Please enter value",
  dbl_chart_condition_action: "Action",
  dbl_chart_condition_delete: "Delete",
  dbl_chart_condition_restore_settings: "Restore Settings",
  dbl_chart_condition_system_default: "System Default",
  dbl_chart_condition_max_less_than_min: "Max cannot be less than min",

  // Table conditional format - HorizontalBar
  dbl_table_metric: "Metric",
  dbl_table_condition_select_metrics: "Select Metrics",
  dbl_table_condition_select_metrics_placeholder: "Please select metrics ",
  dbl_table_condition_merrics: "Merrics",
  dbl_table_condition_rule: "Rule",
  dbl_table_condition_color: "Color",
  dbl_table_condition_icon: "Icon",
  dbl_chart_condition_icon_change: "Change",
  dbl_chart_condition_icon_sentiment: "Sentiment",
  dbl_chart_condition_icon_others: "Others",
  dbl_chart_condition_icon_none: "None",
  dbl_table_condition_color_theme: "Color Theme",
  dbl_table_condition_min: "Min",
  dbl_table_condition_max: "Max",
  dbl_table_condition_auto: "Auto",
  dbl_table_condition_custom_value: "Custom Value",
  dbl_table_condition_custom_value_placeholder: "Please enter value",
  dbl_table_condition_action: "Action",
  dbl_table_condition_delete: "Delete",
  dbl_table_condition_add_condition: "Add Condition",
  dbl_table_condition_max_less_than_min: "Max cannot be less than min",

  // 冻结窗格
  dbl_chart_freeze_panes: 'Freeze Panes',
  dbl_chart_freeze_panes_first: 'Freeze First',
  dbl_chart_freeze_columns: 'Columns',
  dbl_chart_merge_same_cells: 'Merge Same Cells',

  // 数据标签显示
  dbl_chart_show_data_label: 'Show Data Label',
  dbl_chart_display_form: 'Display Form',
  dbl_chart_adaptive: 'Adaptive',
  dbl_chart_adaptive_tips: 'Hide when overlapping',
  dbl_chart_all: 'All',
  dbl_chart_label_content: 'Label Content',
  dbl_chart_label_content_placeholder: 'Please select label content',
  dbl_chart_label_metric: 'Metric',
  dbl_chart_dimension: 'Dimension',
  dbl_chart_percentage: 'Percentage',
  dbl_chart_total: 'Total',

  // 浮窗配置
  dbl_chart_tooltip: 'Tooltip',
  dbl_chart_tooltip_total: 'Total',
  dbl_chart_tooltip_share: '% of Total',
  dbl_chart_tooltip_add: 'Add',
  dbl_chart_tooltip_extra_title: 'Add Extra Content',
  dbl_chart_tooltip_extra_title_edit: 'Edit Extra Content',
  dbl_chart_tooltip_extra_insert_field: 'Insert Field',
  dbl_chart_tooltip_extra_search_field: 'Search for the field name',
  dbl_chart_tooltip_extra_clear_all: 'Clear All',
  dbl_chart_tooltip_extra_preview: 'Preview',
  dbl_chart_tooltip_extra_preview_title: 'Tooltip Preview',
  dbl_chart_tooltip_extra_add_text: 'Add Text',
  dbl_chart_tooltip_extra_text_placeholder: 'Enter fixed text',
  dbl_chart_tooltip_extra_empty_tip: 'No content yet. Add fixed text or insert fields.',
  dbl_chart_tooltip_extra_selected: 'Selected',
  dbl_chart_tooltip_extra_added: 'Added',
  dbl_chart_tooltip_extra_delete_title: 'Delete extra content',
  dbl_chart_tooltip_extra_delete_confirm: 'After deleting, tooltip extra content will not be displayed. Continue?',
  dbl_chart_tooltip_extra_info_tip: 'Add extra content: Supports fixed text or dimension fields.',
  // 设置成功提示
  dbl_chart_config_success: 'Configuration saved successfully！',
  
  // Legend配置
  dbl_chart_legend_setting: 'Legend',
  dbl_chart_legend_color_search: 'Search by legend name',
  dbl_chart_legend_position: 'Position',
  dbl_chart_legend_position_below: 'Below',
  dbl_chart_legend_position_above: 'Above',
  dbl_chart_legend_position_hide: 'Hide',
  // Pivot / Crosstab
  dbl_chart_pivot_crosstab_setting: 'Pivot:Table(Crosstab)',
  dbl_chart_pivot_row: 'Row',
  dbl_chart_pivot_column: 'Column',
  dbl_chart_pivot_available: 'Available Fields',
  dbl_chart_pivot_selected: 'Selected Fields',
};